module.exports = __webpack_public_path__ + "src/assets/games/27/295.jpg";